// src/config.js
// Base URL for QuizMaster API (e.g., document and quiz management)
//export const QUIZMASTER_BASE_URL = 'http://localhost:8000';
//export const QUIZMASTER_BASE_URL = 'https://rogatus-app-latest.onrender.com';
export const QUIZMASTER_BASE_URL = 'https://rogatus-api.fly.dev';
export const QUIZMASTER_API = `${QUIZMASTER_BASE_URL}/v1`;

// Base URL for Aurum API (e.g., wallet, payments, offers)
//export const AURUM_BASE_URL = 'http://localhost:8001'; // Local development URL
//export const AURUM_BASE_URL = 'https://aurum-api-14ku.onrender.com'; // Uncomment for production
//export const AURUM_BASE_URL = 'https://aurum-api-yzus.onrender.com'; // use this one
export const AURUM_BASE_URL = 'https://aurum-api.fly.dev'; // Uncomment for production
export const AURUM_API = `${AURUM_BASE_URL}/v1`; // /v1 suffix, as endpoints dodaes not include it

// Audio files are served through the backend /get-podcast-audio-url/ endpoint